import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmModal } from './confirm/confirm-modal.component';



@NgModule({
  declarations: [ConfirmModal],
  imports: [
    CommonModule
  ],
  entryComponents:[ConfirmModal]
})
export class ModalsModule { }
